module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_7016.7fcda659.png";